import { useMemo } from "react";
import { ExtraStateContext } from "..";
import type { TableColumn } from "../../../../../../components/table";
import { GrantedArea, Photo } from "../../../../components/table-columns";
import { useProcess } from "../../../../process-context";
import { FileAttachmentCard } from "../../../../upload";
import { CopyButton } from "../../../../../../components/Copy-Button/copy";
import { ImagePreview } from "../../../../../../components/image-preview";
import { Button } from "react-bootstrap";
import { FontFa } from "../../../../../../components";

export const useShortTermTableColumns = () => {
  const { isRenew, setOpenUpdateModal, setReqDetail } = useProcess<ExtraStateContext>();

  return useMemo<TableColumn<any>[]>(() => {
    return [
      {
        title: "STT",
        renderCell: (row, rowNumber) => rowNumber,
      },
      {
        title: "Đội/Tổ",
        renderCell: (row) => row.unit,
      },
      {
        title: "Họ và tên",
        renderCell: (row) => (
          <>
            {row.name} <CopyButton value={row.name} />
          </>
        ),
      },
      {
        title: "Nam/Nữ",
        renderCell: (row) => row.sex,
      },
      {
        title: "CMND/CCCD/Hộ chiếu",
        renderCell: (row) => (
          <>
            {row.personalId} <CopyButton value={row.personalId} />
          </>
        ),
      },
      {
        title: "Chức vụ",
        renderCell: (row) => row.regency,
      },
      {
        title: "Số thẻ KSAN đã cấp (Nếu có)",
        renderCell: (row) => row.KSANCardNumberIssued,
      },
      {
        title: "Thời hạn cấp",
        renderCell: (row) => row.grantTerm,
      },
      {
        title: "Khu vực được cấp",
        renderCell: (row) => <GrantedArea data={row.grantedArea ?? []} />,
      },
      {
        title: "Bản CMND photo 6 tháng (mặt trước)",
        renderCell: (row) => <Photo src={row.photocopyOfIDCard} />,
      },
      {
        title: "Bản CMND photo 6 tháng (mặt sau)",
        renderCell: (row) => <Photo src={row.photocopyOfIDCardOpSide} />,
      },
      {
        hidden: !isRenew,
        title: "Đơn cớ mất",
        renderCell: (row) => <FileAttachmentCard listFile={row.excuse ? JSON.parse(row.excuse) : []} />,
      },
      {
        title: "Ngày đến hạn",
        renderCell: (row) => row.expiredDate,
      },
      {
        title: "Hình ảnh khác",
        renderCell: (row) => <ImagePreview imageUrls={row.otherPhoto ? [...row.otherPhoto] : []} />,
      },
      {
        title: "Ghi chú",
        renderCell: (row) => row.note,
      },
      {
        title: "",
        renderCell: (row) => (
          <Button
            title={"Cập nhật ảnh và ngày hết hạn"}
            className=""
            variant="outline"
            onClick={(e: any) => {
              setOpenUpdateModal && setOpenUpdateModal(true);
              setReqDetail(row);
            }}
          >
            <FontFa name="faEdit" size={"lg"} style={{ color: "orange" }} />
          </Button>
        ),
      },
    ];
  }, [isRenew, setOpenUpdateModal, setReqDetail]);
};

export const useLongTermTableColumns = () => {
  const { isRenew, isEvict, setOpenUpdateModal, setReqDetail } = useProcess<ExtraStateContext>();

  return useMemo<TableColumn<any>[]>(() => {
    return [
      {
        title: "STT",
        renderCell: (row, rowNumber) => rowNumber,
      },
      {
        title: "Đội/Tổ",
        renderCell: (row) => row.unit,
      },
      {
        title: "Họ và tên",
        renderCell: (row) => (
          <>
            {row.name} <CopyButton value={row.name} />
          </>
        ),
      },
      {
        title: "Nam/Nữ",
        renderCell: (row) => row.sex,
      },
      {
        title: "CMND/CCCD/Hộ chiếu",
        renderCell: (row) => (
          <>
            {row.personalId} <CopyButton value={row.personalId} />
          </>
        ),
      },
      {
        title: "Chức vụ",
        renderCell: (row) => row.regency,
      },
      {
        hidden: !isEvict && !isRenew,
        title: "Số thẻ KSAN đã cấp (Nếu có)",
        renderCell: (row) => row.KSANCardNumberIssued,
      },
      {
        title: "Thời hạn cấp",
        renderCell: (row) => row.grantTerm,
      },
      {
        title: "Khu vực được cấp",
        renderCell: (row) => <GrantedArea data={row.grantedArea ?? []} />,
      },
      {
        title: "Ảnh thẻ",
        renderCell: (row) => <Photo src={row.cardPhoto} />,
      },
      {
        title: "Bản photo lý lịch tư pháp",
        renderCell: (row) => <Photo src={row.photocopyOfCriminalRecord} />,
      },
      {
        title: "Bản khai cá nhân",
        renderCell: (row) => <Photo src={row.personalStatement} />,
      },
      {
        title: "Bản photo HĐLĐ",
        renderCell: (row) => <Photo src={row.photocopyOfLaborContract} />,
      },
      {
        hidden: !isEvict && !isRenew,
        title: "Bản photo KSAN Cũ",
        renderCell: (row) => <Photo src={row.photoOldKSAN} />,
      },
      {
        hidden: !isRenew,
        title: "Đơn cớ mất",
        renderCell: (row) => <FileAttachmentCard listFile={row.ExcuseLose ? JSON.parse(row.ExcuseLose) : []} />,
      },
      {
        title: "Ngày đến hạn",
        renderCell: (row) => row.expiredDate,
      },
      {
        title: "Hình ảnh khác",
        renderCell: (row) => <ImagePreview imageUrls={row.otherPhoto ? [...row.otherPhoto] : []} />,
      },
      {
        title: "Ghi chú",
        renderCell: (row) => row.note,
      },
      {
        title: "",
        renderCell: (row) => (
          <Button
            title={"Cập nhật ảnh và ngày hết hạn"}
            className=""
            variant="outline"
            onClick={(e: any) => {
              setOpenUpdateModal && setOpenUpdateModal(true);
              setReqDetail(row);
            }}
          >
            <FontFa name="faEdit" size={"lg"} style={{ color: "orange" }} />
          </Button>
        ),
      },
    ];
  }, [isEvict, isRenew, setOpenUpdateModal, setReqDetail]);
};
